<template>
  <!-- Modal -->
  <div class="modal fade" id="PurchaseDetailsModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xxl">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">{{translations('common.addition')}}</h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="alert alert-primary d-flex">
            <input v-model="keyword" class="form-control form-control-sm width-40 mr-2" type="text" :placeholder="translations('common.keyword_search')" @keyup.enter="searchProducts">
            <button type="button" class="btn btn-sm btn-primary" @click="searchProducts()">{{translations('common.search')}}</button>
          </div>
          <div class="table-scroll">
          <table class="table table-striped table-align-middle">
            <vue-element-loading :active="isSearching" spinner="bar-fade-scale" color="#333"/>
            <thead>
              <tr>
                <th>{{translations('purchase.item_number')}}</th>
                <th>{{translations('purchase.jan_code')}}</th>
                <th>{{translations('purchase.model')}}</th>
                <th>{{translations('purchase.unit_price')}}</th>
                <th>{{translations('purchase.count')}}</th>
                <th>{{translations('purchase.summary')}}</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(product, key) in tempDetails">
                <tr :key="key">
                  <td>{{product.item_no}}</td>
                  <td>{{product.jan_code}}</td>
                  <td>{{product.model}}</td>
                  <td><input class="form-control min-width-120" type="text" :placeholder="product.row_price" v-model="product.unit_price"></td>
                  <td><input v-on:keyup="quantityKeyUp($event,product)" class="form-control min-width-120" type="text" v-model="product.quantity"></td>
                  <td><input class="form-control min-width-120" type="text" v-model="product.remarks"></td>
                </tr>
              </template>
            </tbody>
          </table>
          </div>
        </div>
        <div class="modal-footer">
          <button ref="closeModal" type="button" class="btn btn-secondary" data-dismiss="modal">{{translations('common.close')}}</button>
          <button type="button" class="btn btn-primary" @click="updateDetails()">{{translations('common.update')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import { mapState } from 'vuex'

export default {
  name: 'PurchaseDetailsModal',
  components: {
    VueElementLoading
  },
  props: {
    vat: {}, // VAT
    details: {}
  },
  data: function () {
    return {
      tempDetails: [],
      isSearching: false,
      keyword: ''
    }
  },
  mounted () {
    const self = this
    window.$('#PurchaseDetailsModal').on('shown.bs.modal', function () {
      self.onShown()
      window.$('#PurchaseDetailsModal').find('.table-scroll').css('height', (window.innerHeight - 280) + 'px')
    })
  },
  computed: {
    ...mapState(['currentLanguage'])
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    quantityKeyUp (event, product) {
      let { value } = event.target
      if (value && value <= 0) value = 1
      product.quantity = value
    },
    onShown (evt) {
      this.tempDetails = []
      this.keyword = ''
    },

    filterTax (target, taxIncluded = null, vatRate = null) { // VAT INPUT @Modal
      target = target || 0
      taxIncluded = taxIncluded === null ? this.$props.vat.taxIncluded : taxIncluded
      vatRate = vatRate === null ? Number(this.$props.vat.vatRate) : Number(vatRate)
      if (!taxIncluded) {
        return target
      } else {
        let noTax = Math.round(target / ((100 + vatRate) / 100))
        return noTax
      }
    },
    async searchProducts () {
      this.isSearching = true
      try {
        let params = {
          keyword: this.keyword
        }
        console.log('NewOrders:PurchaseDetailsModal:params', params)

        let cList = await this.$http.post(this.$api_url.search_products, params)

        let $data = this.$invoiceTools.prepareResult(cList.data, 'list', 'PurchaseDetailsModal:searchProducts')

        console.log('PurchaseDetailsModal:searchProducts:response', $data)

        if ($data.success === true) {
          this.tempDetails = $data.data
          this.tempDetails.forEach(item => {
            item.unit_price = null
            item.unit_price_inctax = null
            item.remarks = null
          })
        } else {
          this.tempDetails = []
          this.$toastr.error($data.data, 'エラー')
        }
        this.isSearching = false
      } catch (error) {
        console.log('PurchaseDetailsModal:searchProducts:catch(error): ', error)
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
    },

    updateDetails: function () {
      this.tempDetails.forEach(item => {
        let price = 0
        let priceInctax = 0
        if (Number(item.quantity) > 0) {
          console.log(this.vat)
          if (this.vat.taxIncluded) {
            price = this.$util.getExcludeTax(item.unit_price, this.vat.taxRate)
            priceInctax = item.unit_price
          } else {
            price = item.unit_price
            priceInctax = this.$util.getIncludeTax(item.unit_price, this.vat.taxRate)
          }

          item.taxclass_id = 1
          item.tax_rate = this.vat.vatRate
          item.unit_price = price
          item.unit_price_inctax = priceInctax
          this.details.push(item)
        }
      })

      this.$refs.closeModal.click()
    }
  }
}
</script>
